import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/uploaded-docs-log`;

export interface TransactionType {
  id: number;
  name: string;
}

export interface UserOption {
  id: number;
  name: string;
  email: string | null;
}

export interface UploadedDocRow {
  id: number;
  name: string | null;
  transactionTypeId: number | null;
  transactionTypeName: string | null;
  filePath: string | null;
  hasDownload: boolean;
  transactionDate: string | null;
  transactionByUserId: number | null;
  transactionByUserName: string | null;
  activeFlag: number | null;
}

export interface SearchParams {
  fromDate?: string;
  toDate?: string;
  transactionTypeId?: number | null;
  userId?: number | null;
  page: number;
  pageSize: number;
}

export interface SearchResponse {
  rows: UploadedDocRow[];
  pagination: {
    page: number;
    pageSize: number;
    totalPages: number;
    totalRecords: number;
  };
}

export interface LookupsResponse {
  success: boolean;
  data: { transactionTypes: TransactionType[] };
}

export interface UsersSearchResponse {
  success: boolean;
  data: { users: UserOption[] };
}

export interface SearchEnvelope {
  success: boolean;
  data: SearchResponse;
}

export interface SignedUrlResponse {
  success: boolean;
  data: { url: string; fileName: string; expiresIn: number };
}

// myAxios is a JS module, so axios's generic overload picks the wrong slot
// when typed responses are passed in. Use <any> and cast on the consumer side
// (the same pattern as StudentSearchService).
class UploadedDocsLogService {
  getLookups = () => myAxios.get<any>(`${BASE}/lookups`);

  searchUsers = (q: string) =>
    myAxios.get<any>(`${BASE}/users/search`, { params: { q } });

  search = (params: SearchParams) => myAxios.post<any>(`${BASE}/search`, params);

  getSignedUrl = (id: number) => myAxios.get<any>(`${BASE}/${id}/signed-url`);
}

export default new UploadedDocsLogService();
